var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "error-page" }, [
    _c(
      "div",
      { staticClass: "content-con" },
      [
        _c("img", { attrs: { src: _vm.src, alt: _vm.code } }),
        _c("div", { staticClass: "text-con" }, [
          _c("h4", [_vm._v(_vm._s(_vm.code))]),
          _c("h5", [_vm._v(_vm._s(_vm.desc))]),
        ]),
        _c("back-btn-group", { staticClass: "back-btn-group" }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }